import type {ReactNode} from 'react'
import {motion, AnimatePresence} from 'motion/react'
import {ButtonLegacy} from '../../elements/ButtonLegacy'

export interface PromptProps {
  opened: boolean
  header: ReactNode
  content: ReactNode
  onCancel: () => void
  onConfirm: () => void
  cancelText: string
  confirmText: string
  dangerous?: boolean
  confirmDisabled?: boolean
  confirmHasActivity?: boolean
}

export const Prompt = ({
  opened,
  header,
  content,
  onCancel,
  onConfirm,
  cancelText,
  confirmText,
  dangerous,
  confirmDisabled,
  confirmHasActivity,
}: PromptProps) => {
  return (
    <AnimatePresence>
      {opened && (
        <motion.div
          key='overlay'
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          className='absolute inset-0 flex justify-center items-center bg-white/60 z-[20000]'
        >
          <motion.div
            key='content'
            initial={{opacity: 0, translateY: -20}}
            animate={{opacity: 1, translateY: 0}}
            exit={{opacity: 0, translateY: 20}}
            className='w-[550px] bg-white z-[20001] shadow-prompt'
          >
            <div className='p-5 space-y-2.5 text-center'>
              <p className='min-h-[27px] text-tigerSize text-scarpaFlow'>
                {header}
              </p>
              <div className='min-h-16 text-catSize text-santasGray'>
                {content}
              </div>
            </div>
            <div className='p-5 border-t flex justify-between'>
              <ButtonLegacy
                onClick={onCancel}
                width='fixed'
                theme='secondary'
                label={cancelText}
              />
              <ButtonLegacy
                onClick={onConfirm}
                width='fixed'
                theme={dangerous ? 'dangerous' : 'primary'}
                label={confirmText}
                disabled={confirmDisabled}
                hasActivity={confirmHasActivity}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
